@if (Vendor) {
  <div class="container-fluid mt-4 px-4">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md">
            <h2>Trades & Licenses - {{ Vendor.legalName }}</h2>
          </div>
          @if (vendorTradesWithArchivedLicenses.length > 0) {
            <div class="col-12 col-md-2">
              <div class="form-check">
                <label class="form-check-label">Show archived?</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="showArchived"
                />
              </div>
            </div>
          }
        </div>
        @if (Vendor.VendorTrades?.length === 0) {
          <div class="row justify-content-around align-items-center vh-100">
            <h2 class="text-center error-red">No Trades Or Licenses!</h2>
          </div>
        }
        @if (vendorTradesWithNonArchivedLicenses.length > 0) {
          <div class="row">
            @if (showArchived) {
              <h3>Licenses</h3>
              <hr />
            }
            @for (trade of vendorTradesWithNonArchivedLicenses; track trade) {
              <div class="col-12 col-md-4 py-1">
                @if (trade) {
                  <app-display-card
                    [header]="
                      (trade.PrimaryTrade?.name ?? '') +
                      (trade.PrimaryTrade?.defaultTier
                        ? ' - Tier ' +
                          $safeNavigationMigration(
                            trade.PrimaryTrade?.defaultTier
                          )
                        : '')
                    "
                  >
                    <div class="container-fluid p-0">
                      @if (
                        trade.PrimaryTrade?.PrimaryTradeLicenseRequirements &&
                        trade.PrimaryTrade!.PrimaryTradeLicenseRequirements!
                          .length > 0
                      ) {
                        <div class="row g-3">
                          @for (
                            req of trade.PrimaryTrade
                              ?.PrimaryTradeLicenseRequirements;
                            track req
                          ) {
                            @for (license of req.Licenses; track license) {
                              <div
                                class="col-12"
                                [ngClass]="{
                                  'col-md-6':
                                    (req.Licenses && req.Licenses.length > 1) ||
                                    (trade.PrimaryTrade
                                      ?.PrimaryTradeLicenseRequirements)!
                                      .length > 1
                                }"
                              >
                                <div
                                  class="license inner-panel text-center rounded d-flex flex-column justify-content-between h-100"
                                >
                                  <div class="license-content">
                                    <p
                                      class="license-status fs-24 fw-semibold"
                                      appStatusStyleChanges
                                    >
                                      {{ license.status || '' | uppercase }}
                                    </p>
                                    <p class="license-number fw-semibold">
                                      License #:
                                      {{ license.licenseNumber || '' }}
                                    </p>
                                    <p class="license-state fw-semibold">
                                      State Applicable:
                                      {{ license.licenseState || '' }}
                                    </p>
                                    <p class="license-expiration fw-semibold">
                                      Expiration Date:
                                      {{
                                        license.expirationDate
                                          ? (license.expirationDate
                                            | date: 'MM/dd/y')
                                          : 'N/A'
                                      }}
                                    </p>
                                  </div>
                                  @if (
                                    license.licenseFile || license.LicenseFile
                                  ) {
                                    <div class="license-btn">
                                      <button
                                        class="btn btn-primary h-100"
                                        (click)="viewLicense(license)"
                                      >
                                        View License
                                      </button>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if (req.Licenses?.length === 0 && req.isRequired) {
                              <div
                                class="col-12"
                                [ngClass]="{
                                  'col-md-6':
                                    (trade.PrimaryTrade
                                      ?.PrimaryTradeLicenseRequirements)!
                                      .length > 1
                                }"
                              >
                                <div
                                  class="inner-panel rounded text-center h-100 d-flex flex-column justify-content-center"
                                >
                                  <p class="fw-semibold m-0">
                                    Missing required license for {{ req.state }}
                                  </p>
                                </div>
                              </div>
                            }
                            @if (!req.isRequired) {
                              <div
                                class="col-12"
                                [ngClass]="{
                                  'col-md-6':
                                    (trade.PrimaryTrade
                                      ?.PrimaryTradeLicenseRequirements)!
                                      .length > 1
                                }"
                              >
                                <div
                                  class="inner-panel rounded text-center h-100 d-flex flex-column justify-content-center"
                                >
                                  <p class="fw-semibold">
                                    No License Requirements for {{ req.state }}
                                  </p>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      }
                      @if (
                        trade.PrimaryTrade?.PrimaryTradeLicenseRequirements
                          ?.length === 0
                      ) {
                        <div class="row h-100">
                          <div class="col-12">
                            <div
                              class="inner-panel d-flex flex-column justify-content-center text-center rounded h-100 overflow-auto"
                            >
                              <p class="fw-semibold">No License Requirements</p>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </app-display-card>
                }
              </div>
            }
          </div>
        }
        @if (showArchived) {
          <div class="row">
            <div class="col-12">
              <h3 class="pt-4">Archived Licenses</h3>
              <hr />
              @if (
                vendorTradesWithArchivedLicenses &&
                vendorTradesWithArchivedLicenses.length > 0
              ) {
                <div ngbAccordion [closeOthers]="false">
                  @for (
                    trade of vendorTradesWithArchivedLicenses;
                    track trade
                  ) {
                    <div ngbAccordionItem>
                      <h2 ngbAccordionHeader>
                        <button ngbAccordionButton>
                          {{ trade.PrimaryTrade?.name
                          }}{{
                            trade.PrimaryTrade?.defaultTier
                              ? ' - Tier ' + trade.PrimaryTrade?.defaultTier
                              : ''
                          }}
                        </button>
                      </h2>
                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <ng-template>
                            <div class="row g-4">
                              <div class="col-12 col-md-4">
                                @if (trade) {
                                  <app-display-card
                                    [header]="
                                      (trade.PrimaryTrade?.name ?? '') +
                                      (trade.PrimaryTrade?.defaultTier
                                        ? ' - Tier ' +
                                          $safeNavigationMigration(
                                            trade.PrimaryTrade?.defaultTier
                                          )
                                        : '')
                                    "
                                    class="grayScale"
                                  >
                                    @if (
                                      trade.PrimaryTrade
                                        ?.PrimaryTradeLicenseRequirements &&
                                      trade.PrimaryTrade!
                                        .PrimaryTradeLicenseRequirements!
                                        .length > 0
                                    ) {
                                      <div class="row g-3">
                                        @for (
                                          req of trade.PrimaryTrade
                                            ?.PrimaryTradeLicenseRequirements;
                                          track req
                                        ) {
                                          @for (
                                            license of req.Licenses;
                                            track license
                                          ) {
                                            <div
                                              class="col-12"
                                              [ngClass]="{
                                                'col-md-6':
                                                  (req.Licenses &&
                                                    req.Licenses.length > 1) ||
                                                  (trade.PrimaryTrade
                                                    ?.PrimaryTradeLicenseRequirements)!
                                                    .length > 1
                                              }"
                                            >
                                              <div
                                                class="license inner-panel text-center rounded d-flex flex-column justify-content-between h-100"
                                              >
                                                <div class="license-content">
                                                  <p
                                                    class="license-status fs-24 fw-semibold"
                                                    appStatusStyleChanges
                                                  >
                                                    {{
                                                      license.status || ''
                                                        | uppercase
                                                    }}
                                                  </p>
                                                  <p
                                                    class="license-number fw-semibold"
                                                  >
                                                    License #:
                                                    {{
                                                      license.licenseNumber ||
                                                        ''
                                                    }}
                                                  </p>
                                                  <p
                                                    class="license-state fw-semibold"
                                                  >
                                                    State Applicable:
                                                    {{
                                                      license.licenseState || ''
                                                    }}
                                                  </p>
                                                  <p
                                                    class="license-expiration fw-semibold"
                                                  >
                                                    Expiration Date:
                                                    {{
                                                      license.expirationDate
                                                        | date: 'MM/dd/y'
                                                    }}
                                                  </p>
                                                </div>
                                                @if (
                                                  license.licenseFile ||
                                                  license.LicenseFile
                                                ) {
                                                  <div class="license-btn">
                                                    <button
                                                      class="btn btn-primary h-100"
                                                      (click)="
                                                        viewLicense(license)
                                                      "
                                                    >
                                                      View License
                                                    </button>
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          }
                                        }
                                      </div>
                                    }
                                  </app-display-card>
                                }
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
